import React from 'react';
import { FunctionFactory } from 'survey-core';
import { ScienceFamiliarity } from '../quiz/scienceFamiliarity';

const scienceSplashHtml = `
<div class="new-quote-container centered"> 
  <div class="splash-icon">{scienceSplashIcon}</div>
  <div class="splash-header">
    <h1>{scienceSplashTitle}</h1>
    <div class="quote">
      {scienceQuote}
    </div>
  </div>  
</div>`;

const scienceSplashExpression = {
  name: "scienceQuote",
  expression: "renderScienceQuote({science})",
};

function renderScienceQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as ScienceFamiliarity) {
    case ScienceFamiliarity.Very:
      return `Staying informed isn’t easy – your commitment to knowledge shows real dedication.`;
    case ScienceFamiliarity.Somewhat:
      return `You know more than most—now it’s time to turn that knowledge into a plan that works for you, without the overwhelm.`;
    case ScienceFamiliarity.Attempted:
      return `There’s a lot of noise out there. We’ll help you cut through it and focus only on what actually matters.`;
    case ScienceFamiliarity.NotAtAll:
      return "You’ve done your best with the info you had. Now it’s our turn to give you the science-backed clarity you’ve been missing.";
  }
}

FunctionFactory.Instance.register("renderScienceQuote", renderScienceQuote);

function renderScienceSplashIcon(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as ScienceFamiliarity) {
    case ScienceFamiliarity.Very:
      return "🧠";
    case ScienceFamiliarity.Somewhat:
      return "📚";
    case ScienceFamiliarity.Attempted:
      return "🔍";
    case ScienceFamiliarity.NotAtAll:
      return "💪";
  }
}
const scienceSplashIconExpression = {
  name: "scienceSplashIcon",
  expression: "renderScienceSplashIcon({science})",
};
FunctionFactory.Instance.register("renderScienceSplashIcon", renderScienceSplashIcon);

const scienceSplashTitleExpression = {
  name: "scienceSplashTitle",
  expression: "renderScienceSplashTitle({science})",
};
function renderScienceSplashTitle(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as ScienceFamiliarity) {
    case ScienceFamiliarity.Very:
      return `You’re ahead of the curve..`;
    case ScienceFamiliarity.Somewhat:
      return `You’ve done your homework.`;
    case ScienceFamiliarity.Attempted:
      return `Smart to be skeptical`;
    case ScienceFamiliarity.NotAtAll:
      return "Time for an upgrade";
  }
}

FunctionFactory.Instance.register("renderScienceSplashTitle", renderScienceSplashTitle);


const scienceSplashElement = {
  name: 'science-splash',
  type: 'html',
  html: scienceSplashHtml,
}

const ScienceSplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A",
      fontSize: "12px",
    }}>
      📖 Getting to know you better
    </div>
  )
}

export {
  scienceSplashElement,
  scienceSplashExpression,
  scienceSplashIconExpression,
  scienceSplashTitleExpression,
  ScienceSplashHeader,
}